export const MALE = "male";
export const MATCH_PENDING = "pending";
export const MATCH_REJECT = "rejected";
export const MATCH_ACCEPT = "accepted";

export const MISSING_AUDIO = "MISSING_AUDIO";
export const MISSING_PHOTO = "MISSING_PHOTO";
export const MISSING_GENDER = "MISSING_GENDER";
